import React, { useState } from 'react';
import FormDialog from 'components/Dialogs/FormDialog';
import { FinancialsForm } from 'components/Forms';
import { CapTableFormState } from 'components/Forms/CapTableForm/CapTableForm.props';
import { FinancialsVersionDialogProps } from './FinancialsVersionDialog.props';

const FinancialsVersionDialog = (props: FinancialsVersionDialogProps) => {
  const { open, onClose, onSave } = props;

  const [formState, setFormState] = useState<CapTableFormState>();

  const tableTerms = {
    tableName: 'Version',
    tableSlug: 'financial-statement-version',
  };

  return (
    <FormDialog
      open={open}
      title="New Financial Statement Version"
      editMode={false}
      onClose={onClose}
      onSave={() => onSave(formState?.values)}
      isValid={formState?.isValid}>
      <FinancialsForm tableTerms={tableTerms} onFormChange={state => setFormState(state)} />
    </FormDialog>
  );
};

export default FinancialsVersionDialog;
